import React, { useCallback, forwardRef } from 'react'
import { useDispatch } from 'react-redux'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import Grid from '@material-ui/core/Grid'

import roleSchema from '@galo-monitor/forms/schemas/company/role.schema'
import { useT } from '@galo-monitor/i18n'
import { useSnackbar } from '@galo-monitor/snackbar'
import { RoleActions } from '@galo-monitor/stores/role'
import Form from '@galo-monitor/web-components/Form'
import InputText from '@galo-monitor/web-components/InputText'

const FarmRolesForm = forwardRef((props, formRef) => {
  const { role, loading, setLoading, onSuccess, onError } = props
  const dispatch = useCallback(useDispatch(), [])
  const t = useT()
  const snackbar = useSnackbar()

  const handleSubmit = useCallback(
    (data) => {
      setLoading(true)
      dispatch(RoleActions.saveFarmRole(
        {
          ...role,
          ...data
        },
        () => {
          snackbar.success(t('{this} {action} successfully!', {
            this: t('role', { howMany: 1 }),
            action: toLower(t(isEmpty(role) ? 'created' : 'updated', { gender: 'male', howMany: 1 }))
          }))
          onSuccess()
        },
        onError
      ))
    },
    [dispatch, onError, onSuccess, role, setLoading, snackbar, t]
  )

  const schemaConstructor = useCallback(
    (...params) => roleSchema(...params, { role }),
    [role]
  )

  return (
    <Form
      ref={ formRef }
      schemaConstructor={ schemaConstructor }
      onSubmit={ handleSubmit }
    >
      <Grid container spacing={ 2 }>
        <Grid item xs={ 12 }>
          <InputText
            name="name"
            label={ `${ t('name of {this}', { this: t('role', { howMany: 1 }), howMany: 1, gender: 'male' }) } Farm` }
            defaultValue={ role.name }
            disabled={ loading }
            fullWidth
          />
        </Grid>
      </Grid>
    </Form>
  )
})

FarmRolesForm.propTypes = {
  role: PropTypes.object,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

FarmRolesForm.defaultProps = {
  role: {},
  loading: false,
  setLoading: () => {},
  onSuccess: () => {},
  onError: () => {}
}

export default FarmRolesForm
